"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCartPlaceOrder = void 0;
const axios_1 = require("axios");
const react_1 = require("react");
const types_1 = require("../../types");
const apiReducer_1 = require("../../utils/helpers/api/apiReducer");
const token_1 = require("../../utils/helpers/customer/token");
const isGenericReseller_1 = require("../../utils/helpers/isGenericReseller");
const cart_service_1 = require("../services/cart.service");
const utils_1 = require("../utils");
const mapCreateGenericOrderItemsFromCart_1 = require("../utils/mapCreateGenericOrderItemsFromCart");
const mapCreateOrderItemsFromCart_1 = require("../utils/mapCreateOrderItemsFromCart");
const { reducer, initialState } = (0, apiReducer_1.createApiReducer)({
    orderBackofficeId: undefined,
});
const useCartPlaceOrder = () => {
    const [state, dispatch] = (0, react_1.useReducer)(reducer, initialState);
    const placeOrder = (params) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        dispatch({ type: types_1.ApiActionTypeEnum.CALL_API });
        const customerIdFromCookies = (0, token_1.getCustomerId)();
        try {
            let orderBackofficeId;
            if (!params.reseller) {
                throw new Error('Reseller not found');
            }
            if ((0, isGenericReseller_1.isGenericReseller)(params.reseller.catalogSlug)) {
                const data = yield (0, cart_service_1.createGenericOrder)({
                    businessUnit: params.businessUnit,
                    cycle: params.cycleInfo.cycle,
                    items: (0, mapCreateGenericOrderItemsFromCart_1.mapCreateGenericOrderItemsFromCart)(params.items),
                });
                orderBackofficeId = data.orderBackofficeId;
            }
            else {
                const data = yield (0, cart_service_1.createOrder)({
                    businessUnit: params.businessUnit,
                    cycle: params.cycleInfo.cycle,
                    items: (0, mapCreateOrderItemsFromCart_1.mapCreateOrderItemsFromCart)(params.items),
                    catalogSlug: params.reseller.catalogSlug,
                });
                orderBackofficeId = data.orderBackofficeId;
            }
            if (customerIdFromCookies || params.recognizedCustomerToken) {
                let customerIdToPayload = customerIdFromCookies
                    ? { customerId: customerIdFromCookies }
                    : { token: params.recognizedCustomerToken };
                const { customerId: newCustomerId } = yield (0, cart_service_1.assignCustomerToOrder)(Object.assign({ orderBackofficeId }, customerIdToPayload));
                if (!customerIdFromCookies) {
                    (0, token_1.saveCustomerId)(newCustomerId);
                }
            }
            const shareLink = yield (0, utils_1.buildWhatsAppShareOrderLink)({
                orderBackofficeId,
                cycleNumber: params.cycleInfo.cycleNumber,
                cartItems: params.items,
                businessUnit: params.businessUnit,
                reseller: params.reseller,
                similarItems: params.similarItems,
            });
            (0, utils_1.saveOrderDataToLocalStorage)({
                orderBackofficeId,
                shareLink,
                purchaseData: params.items,
            });
            dispatch({
                type: types_1.ApiActionTypeEnum.RESOLVED,
                payload: { orderBackofficeId },
            });
            return orderBackofficeId;
        }
        catch (err) {
            const errorType = types_1.ApiActionTypeEnum.REJECTED;
            if ((0, axios_1.isAxiosError)(err)) {
                dispatch({
                    type: errorType,
                    error: ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) || err,
                });
                return;
            }
            dispatch({
                type: errorType,
                error: err.message || err,
            });
        }
    });
    return {
        placeOrder,
        loading: state.loading,
        error: state.error,
        resolved: state.resolved,
        data: state.orderBackofficeId,
    };
};
exports.useCartPlaceOrder = useCartPlaceOrder;
